import { ELoginScreenState } from "../../Containers/Client/Login/loginConstants";
import ee from "../../components/utils/eventEmitter";
import {
  ILoginObjType,
  IVendorLogin,
} from "../../components/types/components/login/loginTypes";
import {
  indexer,
  jwtToken as IjwtToken,
  TAccData,
  TAccDataRes,
} from "../../components/types/genericTypes";
import JWT from "jwt-decode";
import { ClevertapService } from "../clevertapService";
import { removeTolocalStorage, addTolocalStorage } from "../../Containers/Constants/commenFeatures";

export default class LoginService {
  private static preLoginData: ILoginObjType = {
    userID: "",
    accTyp: "",
    pwd: "",
  };
  private static accData?: TAccData; // data object after login
  private static _jwtToken: string;
  private static _pToken: IjwtToken | null = null;
  static authorization: string;
  static fromUrl?: string; // url from where login was initiated
  static reUrl?: string; // url to redirect after login
  static invtypeobj?: Array<indexer> | indexer; // object to be used in toc after login
  static popupName?: string; // screen state to be shown
  static params?: string; // if any query string needs to be added in reUrl, pass in the form of JSON.stringify
  static vendorDetails?: IVendorLogin; // object when logged in through vendor
  static hideCross = false; // set to true if cross needs to be hidden
  static lgnSrc: string = "";

  static isLoggedIn = () => {
    // check LoginService also because localstorage.setItem is async function
    // jwt_token might not be set in local storage
    let state: boolean =
      localStorage.getItem("jwt_token") || LoginService.jwtToken ? true : false;

    return state;
  };
  static isVendorLoggedIn = () => {
    // access_token might not be set in local storage
    let state: boolean = localStorage.getItem("access_token") ? true : false;
    return state;
  };

  static getPreLoginData = (key: keyof ILoginObjType) => {
    return LoginService.preLoginData[key];
  };

  static setPreLoginData = (obj: { [key in keyof ILoginObjType]?: any }) => {
    LoginService.preLoginData = { ...LoginService.preLoginData, ...obj };
    localStorage.setItem("accntTyp", LoginService.preLoginData.accTyp);
  };

  static getUserID() {
    return localStorage.getItem("user_id");
  }

  static getAccData(key?: keyof TAccData) {
    if (LoginService.accData) {
      if (key) {
        return LoginService.accData[key];
      } else {
        return LoginService.accData;
      }
    } else if (localStorage.getItem("acc_data")) {
      if (key) {
        return JSON.parse(localStorage.getItem("acc_data")!)[key];
      } else {
        return JSON.parse(localStorage.getItem("acc_data")!);
      }
    }
  }

  static setAccData(data: TAccDataRes) {
    const temp: TAccData = {
      ...data,
      userID: data.accs.uid,
      mtf: data.mtf ? data.mtf.sts : "",
      adhrEQ: { stat: data.adhrEQ, brkCode: data.accs.eqBrk },
      adhrCOM: { stat: data.adhrCOM, brkCode: data.accs.coBrk },
      coAccID: data.accs.coAccID,
      eqAccID: data.accs.eqAccID,
      eqRmRt: data.accs.eqRmRt,
      eqAccName: data.accs.eqAccName,
      coAccName: data.accs.coAccName,
      prfId: data.accs.prfId,
      wtspCnsnt: data.accs.wtspCnsnt,
    };
    LoginService.accData = temp;
  }

  static removeAccData() {
    LoginService.accData = undefined;
  }

  static set jwtToken(token: string) {
    LoginService._jwtToken = token;
    LoginService.pToken = token ? JWT(token) : null;
  }

  static get jwtToken() {
    return localStorage.getItem("jwt_token") || this._jwtToken;
  }

  static set pToken(token: IjwtToken | null) {
    LoginService._pToken = token;
  }

  static get pToken() {
    if (!LoginService._pToken) {
      // if _ptoken is not present in login service then fetch from local storage and parse it
      LoginService._pToken = LoginService.jwtToken
        ? JWT(LoginService.jwtToken)
        : null;
    }

    return LoginService._pToken;
  }

  static logout() {
    // Reset all variables in this Service
    LoginService.preLoginData = { userID: "", accTyp: "", pwd: "" };
    LoginService._jwtToken = "";
    LoginService.authorization = "";

    // remove keys from local storage
    localStorage.removeItem("acc_data");
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("appidkey");
    localStorage.removeItem("nesttrader");
    localStorage.removeItem("lgnSrc");
    localStorage.removeItem("accntTyp");
    localStorage.removeItem("LoginFlow");

    LoginService.removeAccData();
    if (LoginService.lgnSrc === "iphone") {
      // TODO
      // window.webkit.messageHandlers.onSessionExpired.postMessage({ "status": "ok" });
    } else if (LoginService.lgnSrc === "X") {
      // TODO
    }
    ee.emit("logout");
  }

  static vendorLogout = () => {
    removeTolocalStorage("loginAs");
    removeTolocalStorage("access_token");
    removeTolocalStorage("tncAccepted");
    removeTolocalStorage("appNm");
    removeTolocalStorage("ldID");
  };

  static saveDataInLocalStorage = () => {
    localStorage.setItem("acc_data", JSON.stringify(getAccData()));
    LoginService.jwtToken &&
      addTolocalStorage("jwt_token", LoginService.jwtToken);
    localStorage.setItem("user_id", getAccData("userID"));
    ee.emit("loginsuccess", {});
  };

  static cleverTapRegistration = () => {
    var clevertapService = new ClevertapService();
    var cleverTapObject = clevertapService.getIdentity();
    var lastcleverTapDetails =
      clevertapService.getClevertapItem("cleverTapDetails");
    var cleverTapDetails =
      LoginService.getAccData("prfId") +
      "," +
      clevertapService.getCleverTapID();

    if (!lastcleverTapDetails || cleverTapDetails !== lastcleverTapDetails) {
      //If registered for the first time
      clevertapService.pushOnUserLogin({
        Site: {
          Name: cleverTapObject.accName, // String
          Identity: cleverTapObject.uniqueId, // It shoulb be accountcode+"-"+accounttype
          AccountType: LoginService.getAccData("accTyp"), // It shoulb be account type
          profileID: LoginService.getAccData("prfId"), //This should be profileID from the login response
        },
      });
      clevertapService.showClevertapNotification();
    }
  };
}

// Add functions here so that they can be easily accessed from any file
export const {
  isLoggedIn,
  isVendorLoggedIn,
  getPreLoginData,
  setPreLoginData,
  getUserID,
  getAccData,
  setAccData,
  removeAccData,
  jwtToken,
  logout,
  vendorLogout,
  saveDataInLocalStorage,
  cleverTapRegistration,
} = LoginService;

/* ******************
 * UTILITY FUNCTIONS *
 ****************** */

/**
 * Parses query string and returns it in the form of object
 * @param queryString String to be parsed. Should contain '?'
 */
export function parseQuery(queryString: string) {
  var query = queryString.substring(1);
  var vars = query.split("&");

  return vars.reduce((acc: indexer, element: string) => {
    var pair: Array<string> = element.split("=");
    acc[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    return acc;
  }, {});
}

/**
 * This function converts an object into query string and returns a string without "?"
 * @param obj object to be converted to query string
 */
export function stringifyQuery(obj: any) {
  let str = [];
  for (let p in obj)
    if (p && obj.hasOwnProperty(p) && obj[p] !== undefined) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export function changeScreen(screenState: ELoginScreenState) {
  ee.emit("changeLoginScreen", screenState);
}

export function setUrlObj(item: IVendorLogin) {
  switch (item.ottype) {
    case "placeorder":
      LoginService.reUrl = "/placeorder";
      break;

    case "order-status":
      LoginService.reUrl = "/orderbook/eq/equity/today";
      LoginService.reUrl += item.sTab || "";
      break;

    case "my-positions":
      LoginService.reUrl = "/position";
      break;

    case "see-margin":
      LoginService.reUrl = "/limits/equity";
      break;

    case "fund-transfer":
      LoginService.reUrl = "/fund-transfer/add-funds";
      // tocUrlObj.status = item.status;
      break;

    case "see-holdings":
      LoginService.reUrl = "/holding/equity/usable";
      break;

    case "margin-files":
      LoginService.reUrl = "/marginfiles/intraday/equity";
      break;

    default:
      LoginService.reUrl = "/placeorder";
  }

  if (LoginService.reUrl === "/placeorder") {
    if (item.data) {
      LoginService.invtypeobj = item.data;

      if (item.isbasket) {
        // TODO
      } else {
        createPlaceOrderUrl(item.data[0]);
      }
    }
  }
}

export function createPlaceOrderUrl(data: any) {
  const aTyp = checkATyp(data);

  LoginService.reUrl += "/" + aTyp + "/";

  if (aTyp === "comm" || aTyp === "curr" || aTyp === "fno") {
    LoginService.reUrl += futOpt(data.symbol) + "/";
  }

  if (aTyp === "mf") {
    LoginService.reUrl += data.isin + "-" + data.scode;
  } else if (data.snse) {
    LoginService.reUrl += data.snse;
  } else if (data.sbse) {
    LoginService.reUrl += data.sbse;
  }
}

// check aType
export function checkATyp(item: indexer) {
  let temp;
  let exc = null;

  if (item.snse) {
    temp = item.snse.split("_");
  } else if (item.sbse) {
    temp = item.sbse.split("_");
  }

  if (temp) {
    exc = temp[temp.length - 1];
  }

  if (exc === "CDS") {
    return "curr";
  } else if (exc === "MCX" || exc === "NCDEX") {
    return "comm";
  }

  if (item.aTyp) {
    return item.aTyp as string;
  } else {
    return "";
  }
}

function futOpt(str: string) {
  if (str.slice(-2) === "CE" || str.slice(-2) === "PE") {
    return "/option";
  } else {
    return "/future";
  }
}
